import React, { useEffect, useState } from 'react'
import { ReactFlowProvider } from '@xyflow/react'
import PositionLayout from './positionLayout'
import Loading from '../../component/loading'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'

function PositionLayoutWithProvider() {
    const [loading, setLoading] = useState(false)
    const [departmentData, setDepartmentData] = useState([])
    const [selectedDepartment, setSelectedDepartment] = useState(null)
    useEffect(() => {
        getDepartment()
    }, [])
    const getDepartment = async () => {
        setLoading(true)
        const responseGet = await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/department`,
            },
            resolve: (res) => {
                setDepartmentData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
            },
        })
    }

    const handlerOnClickDepartment = (department) => {
        setSelectedDepartment(department)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content" style={{ minHeight: '100vh' }}>
                    <Navbar />
                    <div className="flex flex-col mt-6">
                        <div className="flex flex-wrap">
                            {departmentData.map((departmentItem) => (
                                <div
                                    className="main-clr-bg white-clr bd-10 shadowBox p-5 m-3"
                                    onClick={() => {
                                        handlerOnClickDepartment(departmentItem)
                                    }}
                                >
                                    {departmentItem.name}
                                </div>
                            ))}
                            <div></div>
                        </div>
                        <ReactFlowProvider>
                            {selectedDepartment ? (
                                <PositionLayout
                                    selectedDepartment={selectedDepartment}
                                />
                            ) : null}
                        </ReactFlowProvider>
                    </div>
                </main>
            </div>
        </>
    )
}

export default PositionLayoutWithProvider
